export const Bio = {
  name: "Anton Shyrko",
  roles: [
    "Full Stack Developer",
    "Back-End Developer",
    "Startupper",
  ],
  description:
    "A responsible, self-motivated, and active student of the IT department at TUKE\n" +
      "is looking for first back-end development role. I'm passionate about new\n" +
      "technologies, social media, and image processing. I'm a quick learner, a strong\n" +
      "team player, and always ready to tackle new challenges.",
  github: "https://github.com/Antot-12",
  resume:
    "https://drive.google.com/file/d/1D_SweAD0_rLzVFCYY-Lp_AzHbAILZje8/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/anton-shyrko/",
  insta: "https://www.instagram.com/antot__12/",
};


export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Tailwind CSS",
        image: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Tailwind_CSS_Logo.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "C",
        image: "https://upload.wikimedia.org/wikipedia/commons/1/18/C_Programming_Language.svg",
      },
      {
        name: "C++",
        image: "https://upload.wikimedia.org/wikipedia/commons/1/18/ISO_C%2B%2B_Logo.svg",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Flask",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "Grafana",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/grafana/grafana-original.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "TensorFlow",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/2/2d/Tensorflow_logo.svg",
      },
      {
        name: "Keras",
        image:
          "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
      },
      {
        name: "Jupyter",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/jupyter/jupyter-original.svg",
      },
      {
        name: "Google Colab",
        image: "https://colab.research.google.com/img/colab_favicon_256px.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Linux",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/linux/linux-original.svg",
      },
      {
        name: "Adobe",
        image: "https://cdn.worldvectorlogo.com/logos/adobe-2.svg",
      },
      {
        name: "JetBrains (PyCharm, IntelliJ IDEA, CLion)",
        image: "https://resources.jetbrains.com/storage/products/company/brand/logos/jb_beam.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/vscode/vscode-original.svg",
      },
      {
        name: "Figma",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/3/33/Figma-logo.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    role: "Middle Software Engineer",
    company: "SAP",
    date: "Aug 2025 - Present",
    desc: "Developing cloud-based microservices in TypeScript for big data processing & analytics. Designing and consuming internal APIs, focusing on reliability and performance. Working in an international agile team using Jira, code reviews and CI/CD.",
    skills: ["TypeScript", "Microservices", "Cloud", "Big Data", "API Design", "Agile", "CI/CD"],
  },
  {
    id: 1,
    img: "https://img.freepik.com/free-vector/hand-drawn-web-developers_23-2148819604.jpg",
    role: "Full Stack Developer",
    company: "S&S Creation",
    date: "April 2024 - Present",
    desc: "Developed and maintained server-side logic using Node.js, ensuring efficient data processing and communication between AI models and the front-end. Built full-stack components for seamless user experience and robust data management.",
    skills: ["Node.js", "Python", "HTML", "CSS", "JavaScript", "Tailwind CSS", "GIT"],
  },
  {
    id: 2,
    img: "https://cdn-icons-png.flaticon.com/512/2821/2821637.png",
    role: "Manager & Co-Founder",
    company: "S&S Creation",
    date: "April 2024 - Present",
    desc: "Led the development and launch of innovative digital solutions. Co-led the development of 'Magic Mirror' with integrated AI and camera technology, designed for real-time health issue detection. Presented the project at university tech expos, receiving positive industry feedback.",
    skills: ["Project Management", "AI Development", "Computer Vision", "Leadership"],
  },
  {
    id: 3,
    img: "https://upload.wikimedia.org/wikipedia/commons/1/11/EIT-Digital.jpg",
    role: "Winner - Start-up Contest",
    company: "EIT DIGITAL Venture Program",
    date: "April 2024",
    desc: "Won the start-up contest organized by EIT DIGITAL, showcasing an innovative AI-powered product that integrates real-time data analysis and smart user interaction.",
    skills: ["Entrepreneurship", "AI", "Business Development", "Innovation"],
  },
  {
    id: 4,
    img: "https://media.istockphoto.com/id/1189767041/vector/hackathon-signs-round-design-template-thin-line-icon-concept-vector.jpg?s=612x612&w=0&k=20&c=DW-btIjpNjItFfk35N4KvrMkoGoqd1rEPwb_uV9IZEU=",
    role: "Hackathon Participant",
    company: "Erste Digital Košice Hackathon | GymBeam Košice Hackathon",
    date: "November 2023 | October 2024",
    desc: "Participated in the Erste Digital Hackathon and GymBeam Košice Hackathon, developing a tech AI solution under time constraints and competing with top industry talents.",
    skills: ["Problem Solving", "Team Collaboration", "Rapid Prototyping"],
  },
  {
    id: 5,
    img: "https://cdn-icons-png.flaticon.com/512/1048/1048963.png",
    role: "Game Developer",
    company: "LITS Certificate Program",
    date: "September 2020",
    desc: "Completed a Game Development course, learning game mechanics, UI design, and software development in the gaming industry.",
    skills: ["Game Development", "C++", "Unity", "UI/UX"],
  },
];

export const education = [
  {
    id: 0,
    img: "https://cdn.vysokeskoly.cz/vysokeskolysk/get-image/9c776e252a20bb7601a46a964be9187d8a03acc1-500-500-0-0-500-500.jpg",
    school: "Technical University of Košice - Faculty of Electrical Engineering and Informatics (FEI)",
    date: "Sep 2021 – Jun 2026",
    desc: "Completed a Bachelor's degree in Informatics at the Technical University of Košice (TUKE). Courses included Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks.",
    degree: "Bachelor's in Informatics",
  },
  {
    id: 1,
    img: "https://upload.wikimedia.org/wikipedia/uk/3/3c/IPPT.jpg",
    school: "Institute of Entrepreneurship and Advanced Technologies (IPPT) - Lviv Polytechnic National University",
    date: "Sep 2019 – Jun 2021",
    desc: "Completed studies in Computer Science at IPPT, gaining strong programming fundamentals and hands-on experience in software development.",
    degree: "Diploma in Computer Science",
  },
];

export const projects = [
  // TOP 6 FEATURED PROJECTS
  {
    id: 1,
    title: "Coin Flip Simulator",
    description: "A TypeScript application that simulates coin flips with beautiful animations.",
    image: "https://github.com/Antot-12/Coin-Flip-Simulator/raw/main/screens/coin_flip_simulator.png",
    tags: ["TypeScript", "Simulation"],
    category: "web app",
    github: "https://github.com/Antot-12/Coin-Flip-Simulator",
    featured: true,
  },
  {
    id: 2,
    title: "Password Generator",
    description: "A Python application that generates secure passwords with customizable options.",
    image: "https://github.com/Antot-12/Password-Generator/raw/main/screen.png",
    tags: ["Python", "Security"],
    category: "software",
    github: "https://github.com/Antot-12/Password-Generator",
    featured: true,
  },
  {
    id: 3,
    title: "Ping Pong Game",
    description: "A Java implementation of the classic Ping Pong game with smooth gameplay.",
    image: "https://github.com/Antot-12/ping-pong/raw/main/2_pl.png",
    tags: ["Java", "Game"],
    category: "others",
    github: "https://github.com/Antot-12/ping-pong",
    featured: true,
  },
  {
    id: 4,
    title: "URL Shortener",
    description: "A TypeScript URL shortening service for creating compact, shareable links.",
    image: "https://raw.githubusercontent.com/Antot-12/Shorting-URL/master/screenshots/dashboard-desktop.png",
    tags: ["TypeScript", "Web Service"],
    category: "web app",
    github: "https://github.com/Antot-12/Shorting-URL",
    featured: true,
  },
  {
    id: 5,
    title: "Reservation System",
    description: "A full-stack reservation system with frontend, backend, and Telegram bot integration.",
    image: "https://www.bokun.io/wp-content/uploads/2025/07/what-is-reservation-system.jpg",
    tags: ["JavaScript", "Node.js", "Docker"],
    category: "web app",
    github: "https://github.com/Antot-12/Reservation-System",
    featured: true,
  },
  {
    id: 6,
    title: "Bomba Launcher",
    description: "An explosive launcher application with stunning visual effects.",
    image: process.env.PUBLIC_URL + "/images/bomba-launcher.png",
    tags: ["HTML", "JavaScript"],
    category: "others",
    github: "https://github.com/Antot-12/Bomba_Production",
    featured: true,
  },
  // OTHER PROJECTS
  {
    id: 7,
    title: "Weather API",
    description: "A Python-based Weather API that fetches and displays weather information.",
    image: "https://github.com/Antot-12/Weather-API/raw/main/screenshots/1.png",
    tags: ["Python", "API"],
    category: "web app",
    github: "https://github.com/Antot-12/Weather-API",
  },
  {
    id: 8,
    title: "Chat Bot V1",
    description: "A Python-based chatbot application with natural language processing.",
    image: "https://cdn-images-1.medium.com/max/1096/1*uqA2uuCJIxCsVJnxqOsz5Q.png",
    tags: ["Python", "Chatbot"],
    category: "software",
    github: "https://github.com/Antot-12/Chat-Bot-V1",
  },
  {
    id: 9,
    title: "Emoji Translator",
    description: "A Python application that translates text into emojis.",
    image: "https://github.com/Antot-12/Emoji-Translator/raw/main/screens/screenshot.png",
    tags: ["Python", "Translation"],
    category: "web app",
    github: "https://github.com/Antot-12/Emoji-Translator",
  },
  {
    id: 10,
    title: "Totally Not A Malware",
    description: "A Python GUI app demonstrating input validation and email sending.",
    image: "https://github.com/Antot-12/Totally-Not-A-Malware/raw/main/screens/send_data.png",
    tags: ["Python", "Tkinter", "GUI"],
    category: "software",
    github: "https://github.com/Antot-12/Totally-Not-A-Malware",
  },
  {
    id: 11,
    title: "The Greatest Anime Viewer App",
    description: "A React application for browsing, searching, and categorizing anime.",
    image: "https://github.com/Antot-12/The-Greatest-Anime-Viewer-App/raw/main/screens/screenshot1.png",
    tags: ["JavaScript", "React", "Flask"],
    category: "web app",
    github: "https://github.com/Antot-12/The-Greatest-Anime-Viewer-App",
  },
  {
    id: 12,
    title: "Pack Together",
    description: "A React app for organizing and managing your packing list.",
    image: "https://github.com/Antot-12/Pack-React-Site/raw/main/src/screens/stats-view.png",
    tags: ["JavaScript", "React"],
    category: "web app",
    github: "https://github.com/Antot-12/Pack-React-Site",
  },
  {
    id: 13,
    title: "MadPan Minecraft Hotel Plugin",
    description: "A Minecraft plugin to automatically build multi-story hotels.",
    image: "https://cdn-icons-png.flaticon.com/512/2111/2111425.png",
    tags: ["Java", "Minecraft"],
    category: "others",
    github: "https://github.com/Antot-12/MadPan-minecraft-hotel-plugin-1.12.2",
  },
  {
    id: 14,
    title: "Azur Lane Site",
    description: "A cyberpunk UI website with interactive elements.",
    image: "https://github.com/Antot-12/Azur-Lane-Site/raw/main/screens/home_page.png",
    tags: ["HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/Antot-12/Azur-Lane-Site",
  },
  {
    id: 15,
    title: "Recipe Bot - Telegram",
    description: "A Java Telegram bot for exploring recipes and cooking tips.",
    image: "https://miro.medium.com/v2/resize:fit:602/1*PtxV-2L5n3fOkdVyDLphMQ.jpeg",
    tags: ["Java", "Telegram API"],
    category: "others",
    github: "https://github.com/Antot-12/Telegram-Bot-Java",
  },
  {
    id: 16,
    title: "Azirov Translator",
    description: "A neon-themed Ukrainian-to-Aziriv translator. Mobile-ready, offline-capable.",
    image: "https://raw.githubusercontent.com/Antot-12/Azirov/main/image/screenshot.png",
    tags: ["JavaScript", "PWA"],
    category: "web app",
    github: "https://github.com/Antot-12/Azirov",
    webapp: "https://antot-12.github.io/Azirov/",
  },
  {
    id: 17,
    title: "WeatherPulse Dashboard",
    description: "A modern weather dashboard with real-time data and beautiful visualizations.",
    image: "https://raw.githubusercontent.com/Antot-12/WeatherPulse-Dashboard/main/docs/screenshots/dashboard-main.png",
    tags: ["TypeScript", "React", "API"],
    category: "web app",
    github: "https://github.com/Antot-12/WeatherPulse-Dashboard",
    webapp: "https://antot-12.github.io/WeatherPulse-Dashboard/",
  },
  {
    id: 18,
    title: "NEON DYSTOPIA",
    description: "A cyberpunk-themed interactive web game with neon aesthetics.",
    image: "https://raw.githubusercontent.com/Antot-12/NEON-DYSTOPIA/main/pics/start.png",
    tags: ["HTML", "CSS", "Game"],
    category: "others",
    github: "https://github.com/Antot-12/NEON-DYSTOPIA",
  },
  {
    id: 19,
    title: "Neon Snake",
    description: "Classic Snake game reimagined with stunning neon visuals.",
    image: "https://raw.githubusercontent.com/Antot-12/Neon-Snake/main/imgs/language-toggle.png",
    tags: ["JavaScript", "Game"],
    category: "others",
    github: "https://github.com/Antot-12/Neon-Snake",
  },
  {
    id: 20,
    title: "SafeLink Inspector",
    description: "A security tool to analyze URLs for potential threats.",
    image: "https://raw.githubusercontent.com/Antot-12/SafeLinkInspector/main/docs/screenshot-analyzer.png",
    tags: ["JavaScript", "Security", "Next.js"],
    category: "web app",
    github: "https://github.com/Antot-12/SafeLinkInspector",
  },
  {
    id: 21,
    title: "LinkedIn Text Formatter",
    description: "Rich text editor for LinkedIn posts with live preview.",
    image: "https://raw.githubusercontent.com/Antot-12/Linkedin-Text-Formatter/main/src/assets/preview.png",
    tags: ["TypeScript", "React"],
    category: "web app",
    github: "https://github.com/Antot-12/Linkedin-Text-Formatter",
  },
  {
    id: 22,
    title: "Web Crawler",
    description: "A fast web crawler built with Go for scraping web content.",
    image: "https://cdn-icons-png.flaticon.com/512/2282/2282188.png",
    tags: ["Go", "CLI"],
    category: "software",
    github: "https://github.com/Antot-12/Web-Crawler",
  },
  {
    id: 23,
    title: "Neon Geo Guess",
    description: "A geography guessing game with neon aesthetics.",
    image: "https://raw.githubusercontent.com/Antot-12/Neon-Geo-Guess/main/docs/game.jpg",
    tags: ["JavaScript", "Game"],
    category: "others",
    github: "https://github.com/Antot-12/Neon-Geo-Guess",
  },
  {
    id: 24,
    title: "Duck Python Game",
    description: "A fun Python game featuring ducks and interactive gameplay.",
    image: "https://cdn-icons-png.flaticon.com/512/1864/1864514.png",
    tags: ["Python", "Game"],
    category: "others",
    github: "https://github.com/Antot-12/Duck_Python_Game",
  },
  {
    id: 25,
    title: "Gravity Defied",
    description: "A Python physics-based game inspired by the classic mobile game.",
    image: "https://raw.githubusercontent.com/Antot-12/Gravity-Defied/main/screenshot.png",
    tags: ["Python", "Game"],
    category: "others",
    github: "https://github.com/Antot-12/Gravity-Defied",
  },
  {
    id: 26,
    title: "Calculator C++",
    description: "A calculator application built with C++.",
    image: "https://cdn-icons-png.flaticon.com/512/891/891226.png",
    tags: ["C++", "CLI"],
    category: "software",
    github: "https://github.com/Antot-12/Calculator_cpp",
  },
  {
    id: 27,
    title: "Tic Tac Toe",
    description: "Classic Tic Tac Toe game implemented in Java.",
    image: "https://cdn-icons-png.flaticon.com/512/566/566294.png",
    tags: ["Java", "Game"],
    category: "others",
    github: "https://github.com/Antot-12/tiktaktoe",
  },
  {
    id: 28,
    title: "TODO List",
    description: "A Python-based task management application.",
    image: "https://raw.githubusercontent.com/Antot-12/TODO-list/main/to_do.png",
    tags: ["Python"],
    category: "software",
    github: "https://github.com/Antot-12/TODO-list",
  },
  {
    id: 29,
    title: "Blog React",
    description: "A React-based blog platform with modern design.",
    image: "https://raw.githubusercontent.com/Antot-12/Blog-React/main/screens/home.png",
    tags: ["JavaScript", "React"],
    category: "web app",
    github: "https://github.com/Antot-12/Blog-React",
  },
  {
    id: 30,
    title: "Avatar Generator",
    description: "Generate unique avatars with customizable features.",
    image: "https://raw.githubusercontent.com/Antot-12/The-Greatest-Avatar-Generator/main/imgs/avatar_generator_demo.png",
    tags: ["JavaScript"],
    category: "web app",
    github: "https://github.com/Antot-12/The-Greatest-Avatar-Generator",
  },
  {
    id: 31,
    title: "Hacker Console",
    description: "A Python hacker-style console simulator.",
    image: "https://raw.githubusercontent.com/Antot-12/Hacker-Console/main/screens/menu.png",
    tags: ["Python", "CLI"],
    category: "software",
    github: "https://github.com/Antot-12/Hacker-Console",
  },
  {
    id: 32,
    title: "Dungeon Pub Site",
    description: "A TypeScript web application for a dungeon-themed pub.",
    image: "https://cdn-icons-png.flaticon.com/512/2144/2144768.png",
    tags: ["TypeScript"],
    category: "web app",
    github: "https://github.com/Antot-12/Dungeon-Pub-Site",
  },
  {
    id: 33,
    title: "Credit Card Form",
    description: "A beautiful credit card form with CSS animations.",
    image: "https://raw.githubusercontent.com/Antot-12/Credit-Card-HTML/main/screen/demo.png",
    tags: ["HTML", "CSS"],
    category: "web app",
    github: "https://github.com/Antot-12/Credit-Card-HTML",
  },
  {
    id: 34,
    title: "Guess A Number",
    description: "A number guessing game built with React Native.",
    image: "https://raw.githubusercontent.com/Antot-12/React-Native---Guess-A-Number/main/screenshots/start-screen.png",
    tags: ["React Native", "Mobile"],
    category: "others",
    github: "https://github.com/Antot-12/React-Native---Guess-A-Number",
  },
  {
    id: 35,
    title: "Spekulus",
    description: "A TypeScript project with modern web technologies.",
    image: "https://raw.githubusercontent.com/Antot-12/Spekulus/master/public/spekulus-homepage.png",
    tags: ["TypeScript"],
    category: "web app",
    github: "https://github.com/Antot-12/Spekulus",
  },
  {
    id: 36,
    title: "Widget Store",
    description: "A TypeScript widget marketplace application.",
    image: "https://raw.githubusercontent.com/Antot-12/Widget-Store/master/pic/image_ff2f97c9-4eb9-4a21-879e-0f01fa431975.png",
    tags: ["TypeScript"],
    category: "web app",
    github: "https://github.com/Antot-12/Widget-Store",
  },
  {
    id: 37,
    title: "Unit Converter",
    description: "A Python unit converter with multiple conversion types.",
    image: "https://raw.githubusercontent.com/Antot-12/The-Greatest-Connventer/main/screenshots/4.png",
    tags: ["Python", "CLI"],
    category: "software",
    github: "https://github.com/Antot-12/The-Greatest-Connventer",
  },
  {
    id: 38,
    title: "Say NO",
    description: "Say 'No' like a Pro - a fun TypeScript application.",
    image: "https://raw.githubusercontent.com/Antot-12/NO/main/pics/screenshot.png",
    tags: ["TypeScript"],
    category: "web app",
    github: "https://github.com/Antot-12/NO",
  },
  {
    id: 39,
    title: "C# Automation Tester",
    description: "C# assignment for automation testing with practical examples.",
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg",
    tags: ["C#", "Testing"],
    category: "software",
    github: "https://github.com/Antot-12/C-Assignment-for-Automation-Tester",
  },
  {
    id: 40,
    title: "C Tasks",
    description: "Collection of C programming tasks and exercises.",
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/c/c-original.svg",
    tags: ["C"],
    category: "software",
    github: "https://github.com/Antot-12/C-tasks",
  },
  {
    id: 41,
    title: "C++ Tasks",
    description: "Collection of C++ programming tasks and exercises.",
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg",
    tags: ["C++"],
    category: "software",
    github: "https://github.com/Antot-12/Cpp-tasks",
  },
  {
    id: 42,
    title: "Java Practice",
    description: "Java programming practice projects and exercises.",
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
    tags: ["Java"],
    category: "software",
    github: "https://github.com/Antot-12/Java_practice",
  },
  {
    id: 43,
    title: "Key Logger",
    description: "A Python keylogger for educational purposes.",
    image: "https://cdn-icons-png.flaticon.com/512/2716/2716607.png",
    tags: ["Python", "Security"],
    category: "software",
    github: "https://github.com/Antot-12/Key-Logger",
  },
  {
    id: 44,
    title: "Python Labs",
    description: "Python laboratory assignments and projects.",
    image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    tags: ["Python"],
    category: "software",
    github: "https://github.com/Antot-12/Labs",
  },
  {
    id: 45,
    title: "Mass Tool",
    description: "A Python mass processing utility tool.",
    image: "https://cdn-icons-png.flaticon.com/512/1828/1828490.png",
    tags: ["Python"],
    category: "software",
    github: "https://github.com/Antot-12/Mass",
  },
  {
    id: 46,
    title: "Password Generator Java",
    description: "Secure password generator built with Java.",
    image: "https://raw.githubusercontent.com/Antot-12/Password-Generator-Java/main/screenshots/1.png",
    tags: ["Java", "Security"],
    category: "software",
    github: "https://github.com/Antot-12/Password-Generator-Java",
  },
  {
    id: 47,
    title: "PWA Testing App",
    description: "Progressive Web App testing application.",
    image: "https://raw.githubusercontent.com/Antot-12/PWA-testing-app/main/docs/screen1.png",
    tags: ["TypeScript", "PWA"],
    category: "web app",
    github: "https://github.com/Antot-12/PWA-testing-app",
  },
  {
    id: 48,
    title: "Reddit Scripts",
    description: "Python automation scripts for Reddit.",
    image: "https://cdn-icons-png.flaticon.com/512/2111/2111589.png",
    tags: ["Python", "Automation"],
    category: "software",
    github: "https://github.com/Antot-12/Reddit-Scripts",
  },
  {
    id: 49,
    title: "File Renamer",
    description: "A Python utility for batch file renaming.",
    image: "https://raw.githubusercontent.com/Antot-12/Renamer/main/pic.png",
    tags: ["Python", "CLI"],
    category: "software",
    github: "https://github.com/Antot-12/Renamer",
  },
  {
    id: 50,
    title: "Antotopedia",
    description: "A TypeScript knowledge base project.",
    image: "https://cdn-icons-png.flaticon.com/512/2232/2232688.png",
    tags: ["TypeScript"],
    category: "web app",
    github: "https://github.com/Antot-12/Antotopedia_12",
  },
  {
    id: 51,
    title: "Link Worker",
    description: "A TypeScript link management worker.",
    image: "https://cdn-icons-png.flaticon.com/512/3214/3214746.png",
    tags: ["TypeScript", "Worker"],
    category: "web app",
    github: "https://github.com/Antot-12/Link-Worker",
  },
  {
    id: 52,
    title: "Web Snapchat Fix",
    description: "JavaScript fix for web Snapchat issues.",
    image: "https://cdn-icons-png.flaticon.com/512/3536/3536445.png",
    tags: ["JavaScript"],
    category: "web app",
    github: "https://github.com/Antot-12/Web-snapchat-fix",
  },
  {
    id: 53,
    title: "Electron Test",
    description: "Testing Electron framework for desktop apps.",
    image: "https://cdn-icons-png.flaticon.com/512/5968/5968672.png",
    tags: ["JavaScript", "Electron"],
    category: "software",
    github: "https://github.com/Antot-12/Electron-test-",
  },
  {
    id: 54,
    title: "GitHub Neon Portfolio",
    description: "A neon-styled GitHub portfolio template.",
    image: "https://raw.githubusercontent.com/Antot-12/github-neon-portfolio/main/preview.png",
    tags: ["JavaScript", "Portfolio"],
    category: "web app",
    github: "https://github.com/Antot-12/github-neon-portfolio",
  },
  {
    id: 55,
    title: "Spekulus Presentation",
    description: "Interactive presentation for Spekulus project.",
    image: "https://raw.githubusercontent.com/Antot-12/Spekulus-Presentation/main/screens/desktop.png",
    tags: ["CSS", "Presentation"],
    category: "web app",
    github: "https://github.com/Antot-12/Spekulus-Presentation",
    webapp: "https://antot-12.github.io/Spekulus-Presentation/",
  },
  {
    id: 56,
    title: "Portfolio V1",
    description: "First version of my portfolio website.",
    image: "https://cdn-icons-png.flaticon.com/512/3135/3135768.png",
    tags: ["JavaScript", "Portfolio"],
    category: "web app",
    github: "https://github.com/Antot-12/Prortfolio-V1",
    webapp: "https://antot-12.github.io/Prortfolio-V1/",
  },
];

export const certifications = [
  {
    id: 1,
    name: "Machine Learning with Python Professional Certificate",
    issuer: "Anaconda",
    date: "Feb 2026",
    logo: "https://upload.wikimedia.org/wikipedia/en/c/cd/Anaconda_Logo.png",
    skills: ["AI", "Python", "Machine Learning"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
    featured: true,
  },
  {
    id: 2,
    name: "Machine Learning with Python: Foundations",
    issuer: "SAP",
    date: "Jan 2026",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["AI", "Python", "Machine Learning"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
    featured: true,
  },
  {
    id: 3,
    name: "Career Essentials in GitHub Copilot Professional Certificate",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["AI Software Development", "AI Productivity", "GitHub Copilot"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
    featured: true,
  },
  {
    id: 4,
    name: "Artificial Intelligence Foundations: Machine Learning",
    issuer: "SAP",
    date: "Dec 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["Machine Learning", "AI"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 5,
    name: "Modern CSS Techniques without JavaScript",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["JavaScript", "CSS", "HTML5"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 6,
    name: "Build with AI: Create a Local AI Agent with Gemma",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["AI", "Generative AI", "AI Agents"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 7,
    name: "Mastering Model Context Protocol (MCP)",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["AI", "AI Software Development", "MCP"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 8,
    name: "Microsoft Security Essentials",
    issuer: "NASBA",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
    skills: ["Microsoft Security", "GRC", "Cloud Security"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 9,
    name: "Java Profiling",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["Java", "OOP"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 10,
    name: "Generative AI: Working with Large Language Models",
    issuer: "NASBA",
    date: "Aug 2025",
    logo: "https://cdn-icons-png.flaticon.com/512/8637/8637099.png",
    skills: ["LLM", "AI", "Generative AI"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 11,
    name: "Practical GitHub Project Management",
    issuer: "PMI",
    date: "Aug 2025",
    logo: "https://cdn-icons-png.flaticon.com/512/5968/5968866.png",
    skills: ["GitHub", "Project Management"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 12,
    name: "TypeScript Design Patterns",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["TypeScript", "OOP", "Design Patterns"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 13,
    name: "Critical Thinking and Problem Solving",
    issuer: "PMI",
    date: "Nov 2025",
    logo: "https://cdn-icons-png.flaticon.com/512/5968/5968866.png",
    skills: ["Critical Thinking", "Problem Solving"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 14,
    name: "Building Scalable Microservices with TypeScript and Node.js",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["Microservices", "TypeScript", "Node.js", "DevOps"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 15,
    name: "Model Context Protocol (MCP): Hands-On with Agentic AI",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["AI Agents", "Anthropic Claude", "MCP"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 16,
    name: "Google Gemini for Developers",
    issuer: "SAP",
    date: "Oct 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["Google Gemini", "Generative AI", "Prompt Engineering"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 17,
    name: "TypeScript Essential Training",
    issuer: "SAP",
    date: "Aug 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["TypeScript", "JavaScript", "Node.js"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 18,
    name: "Career Essentials in GitHub Professional Certificate",
    issuer: "SAP",
    date: "Aug 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["GitHub", "Git", "GitFlow"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 19,
    name: "Start Writing Prompts like a Pro",
    issuer: "Google",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg",
    skills: ["AI", "Prompt Engineering"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 20,
    name: "AI: Start",
    issuer: "Google",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/c/c1/Google_%22G%22_logo.svg",
    skills: ["AI", "Prompt Engineering"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 21,
    name: "Pitching Yourself for Opportunity",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["Pitch Development", "Self Promotion"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 22,
    name: "How to Speak Smarter When Put on the Spot",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["Public Speaking", "Communication"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 23,
    name: "Python Practice: Object-Oriented Programming",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["Python", "OOP"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
  {
    id: 24,
    name: "JavaScript Practice: Object-Oriented Programming",
    issuer: "SAP",
    date: "Nov 2025",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg",
    skills: ["JavaScript", "OOP"],
    link: "https://www.linkedin.com/in/anton-shyrko/",
  },
];

